import { HashRouter, Routes } from 'react-router-dom';
import CRoutes from './routes';

export default () => (
    <HashRouter>
        <Routes>
            {/* <Route path="/" element={<App />} /> */}
            {CRoutes()}
            {/* <Route path="*" element={<NotFound />} /> */}
        </Routes>
    </HashRouter>
);
